import React from 'react';
import { withRouter } from 'react-router-dom';

class GoogleAnalytics extends React.Component {
    
    state = {}

    static getDerivedStateFromProps(props, state){
        const gtag = window.gtag;

        if (typeof(gtag) === 'function') {
            gtag('event', 'page_view', {
                page_title: window.title,
                page_location: window.location.pathname,
                page_path: window.location.pathname,
                send_to: process.env.REACT_APP_GA_TRACKING_ID
              })
        }

        return null
    }

    render () {
        return null;
    }
}

export default withRouter(GoogleAnalytics);